import {
  REPLENISHMENT_RULE_FETCH,
  REPLENISHMENT_RULE_RECEIVED,
  REPLENISHMENT_RULE_ERROR,
  REPLENISHMENT_RULE_CLEAR_ERROR,
} from '../actions/replenishRule';

const initialState = {
  fetching: false,
  rule: undefined,
  error: '',
  planogram: null,
  planogramImageUrl: null,
};

const replenishRuleReducer = (state = initialState, action) => {
  switch (action.type) {
    case REPLENISHMENT_RULE_FETCH:
      return {
        ...state,
        fetching: true,
      };
    case REPLENISHMENT_RULE_RECEIVED:
      return {
        ...state,
        fetching: false,
        rule: action.rule,
        planogram: action.planogram,
        planogramImageUrl: action.planogramImageUrl,
      };
    case REPLENISHMENT_RULE_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    case REPLENISHMENT_RULE_CLEAR_ERROR:
      return {
        ...state,
        error: '',
        fetching: false,
      };
    default:
      return state;
  }
};

export default replenishRuleReducer;
